import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import initializers from '../../dependencies/initializers'



import imgHero from '../../images/hero_img_apis.png'
import imgSectionOne from '../../images/img_apis_01.png'
import imgSectionTwo from '../../images/img_apis_02.png'
import imgRoundedRightTop from '../../images/rounded_top_right.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'

class apis extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

  render() {
    const {
      globalGetLanguages,
      user
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text apis">
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'AI_APIS_TITLE_1'))}</div>
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'AI_APIS_TITLE_2'))}</div>
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'AI_APIS_TITLE_3'))}</div>
              

              <div className='content-desc'>
                {renderHTML(translate(globalGetLanguages,'AI_APIS_TEXT'))}
              </div>

              <div className={`ban-link`}>
                <a onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('apis', 'button_talk_to_an_expert');
                }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
              </div>
              <div className={`ban-link hide`}>
                <a onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-right-top">
            <img src={imgRoundedRightTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionOne} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                {renderHTML(translate(globalGetLanguages,'TEXT_APIS_TITLE_1'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_APIS_DESC_1'))}</p>
                  <p style={{ fontSize: '16px' }}>{renderHTML(translate(globalGetLanguages,'TEXT_APIS_FEAURES_1_SUB_1'))}</p>
                 
                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionTwo} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                  {renderHTML(translate(globalGetLanguages,'TEXT_APIS_TITLE_2'))}

                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_APIS_DESC_2'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_APIS_FEATURES_2_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_APIS_FEATURES_2_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_APIS_FEATURES_2_SUB_3'))}</li>
                  </ul>
                  <div className={`ban-link m-t-30`}>
                    <a href={`${initializers.dev_host}/api-documentation`} target="_blank" rel="noopener noreferrer"
                      onClick={() => accesslog('apis', 'button_view_api_documentation')}
                    >{translate(globalGetLanguages,'BUTTON_API_DOCUMENTATION')}</a>
                  </div>

                </div>
              </div>
            </div> 
          </section>
      </div>
      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Trusted by Education Platforms, Job <br />Boards, and Enterprise HR Tech</h1>
              <h4>From job portals to digital academies, ASTRNT powers structured evaluation across industries. If you're building <br />tools for hiring or learning, our APIs are ready to support your flow.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <a onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('apis', 'button_talk_to_an_expert');
                  }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
                </div>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(apis)
